import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/webhooks/webhook-endpoints/:endpointId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    endpointId: string;
}
const mutationFn = ({ endpointId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { endpointId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteWebhookEndpoint };
